export enum ROLES {
  CITIZEN = 'citizen',
}
export enum UNREGISTERED_ROLES {
  INDIVIDUAL = 'unregistered-individual',
  ENTREPRENEUR = 'unregistered-entrepreneur',
  LEGAL = 'unregistered-legal',
}
